/*
  Verhalten der Melfmade-Produktseite.

  Vanilla, kein Framework -- entsprechend der Vorgabe fuer dieses Theme.

  Drei Dinge:
    1. Bildwechsel ueber die kleinen Ansichten
    2. Mengenwahl als Plus-Minus
    3. Staffelstufen setzen die Menge direkt

  Der Warenkorb selbst laeuft weiter ueber Dawns product-form: Das Formular
  steckt in einem <product-form>-Element, dadurch greift die vorhandene
  Logik samt Toast-Benachrichtigung. Ein eigener Absende-Weg waere ein
  zweiter Pfad in den Warenkorb, den man doppelt pflegen muesste.
*/
(function () {
  var wurzel = document.querySelector('.melf-pdp');
  if (!wurzel) return;

  // --- Bildwechsel ---------------------------------------------------
  var haupt = wurzel.querySelector('[data-rolle=haupt]');
  wurzel.addEventListener('click', function (e) {
    var mini = e.target.closest && e.target.closest('.melf-pdp__mini-knopf');
    if (!mini || !haupt) return;
    var gross = mini.getAttribute('data-gross');
    if (!gross) return;
    haupt.src = gross;
    wurzel.querySelectorAll('.melf-pdp__mini-knopf').forEach(function (k) {
      k.classList.toggle('ist-aktiv', k === mini);
    });
  });

  // --- Menge ----------------------------------------------------------
  var feld = wurzel.querySelector('[data-rolle=menge]');

  function setzeMenge(n) {
    if (!feld) return;
    feld.value = Math.max(1, n);
    // Ereignis auslesbar machen, falls andere Skripte darauf horchen
    feld.dispatchEvent(new Event('change', { bubbles: true }));
    markiereStufe();
  }

  /* Die Stufe wird hervorgehoben, sobald die Menge sie erreicht -- auch
     wenn jemand die Zahl von Hand eintippt. Sonst wuerde die Markierung
     nur beim Klick stimmen und danach luegen. */
  function markiereStufe() {
    if (!feld) return;
    var n = parseInt(feld.value, 10) || 0;
    var erreicht = null;
    wurzel.querySelectorAll('.melf-pdp__stufe').forEach(function (s) {
      var m = parseInt(s.getAttribute('data-menge'), 10);
      if (n >= m) erreicht = s;
    });
    wurzel.querySelectorAll('.melf-pdp__stufe').forEach(function (s) {
      s.classList.toggle('ist-aktiv', s === erreicht);
    });
  }

  wurzel.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('[data-schritt]');
    if (knopf && feld) {
      setzeMenge((parseInt(feld.value, 10) || 1) + parseInt(knopf.getAttribute('data-schritt'), 10));
      return;
    }
    var stufe = e.target.closest && e.target.closest('.melf-pdp__stufe');
    if (stufe) setzeMenge(parseInt(stufe.getAttribute('data-menge'), 10));
  });

  if (feld) {
    feld.addEventListener('input', markiereStufe);
    markiereStufe();
  }

  // --- Variantenwahl --------------------------------------------------
  var wahl = wurzel.querySelector('[data-rolle=wahl]');
  var versteckt = wurzel.querySelector('[data-rolle=variante]');
  if (wahl && versteckt) {
    wahl.addEventListener('change', function () {
      versteckt.value = wahl.value;
    });
  }

  // --- Versandkostenfrei ----------------------------------------------
  /* Der Warenkorbstand kommt aus /cart.js und nicht aus Liquid: Liquid
     rendert einmal beim Seitenaufbau, der Warenkorb aendert sich aber
     danach noch -- etwa durch Quick Add in einem anderen Reiter. */
  var zeile = wurzel.querySelector('[data-frei-ab]');
  if (!zeile) return;
  var ziel = parseInt(zeile.getAttribute('data-frei-ab'), 10);
  var anzeige = zeile.querySelector('[data-rolle=frei]');
  if (!ziel || !anzeige) return;

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (w) {
      var fehlt = ziel - w.total_price;
      if (fehlt <= 0) {
        anzeige.textContent = 'Dein Versand ist kostenfrei.';
        zeile.classList.add('melf-pdp__vertrauen--erreicht');
      } else if (w.total_price > 0) {
        anzeige.textContent =
          'Noch ' + (fehlt / 100).toFixed(2).replace('.', ',') + ' € bis zum kostenfreien Versand.';
      }
      /* Bei leerem Warenkorb bleibt der Liquid-Text stehen: "Noch 69 € bis
         versandkostenfrei" waere bei null Artikeln keine Motivation,
         sondern eine Huerde. */
    })
    .catch(function () {});
})();
